<template>
  <div class="editor">
    <vue-headful :title="title + ' - Murderer\'s Notebook'" />
    <EditableTitle v-model="title" />
    <StoryView v-model="story" />
    <CharacterList v-model="characters" />
    <Timeline v-model="timeline" :characters="characters" />
    <EvidenceList v-model="evidences" />
    <div class="section">
      <h3 class="mt-4">その他</h3>
      <textarea class="form-control" rows="30" v-model="others"></textarea>
    </div>
  </div>
</template>

<script>
import EditableTitle from '@/components/EditableTitle.vue'
import StoryView from '@/components/StoryView.vue'
import CharacterList from '@/components/CharacterList.vue'
import Timeline from '@/components/Timeline.vue'
import EvidenceList from '@/components/EvidenceList.vue'

export default {
  name: 'Editor',

  components: {
    EditableTitle,
    StoryView,
    CharacterList,
    Timeline,
    EvidenceList
  },

  created(){
    const key = this.$route.params.id
    const item = localStorage.getItem('session-' + key)
    if(!item){
      this.$router.push({ name: 'Home' })
      return
    }
    const obj = JSON.parse(item)
    this.$store.dispatch('setTitle',      obj.title)
    this.$store.dispatch('setStory',      obj.story)
    this.$store.dispatch('setCharacters', obj.characters)
    this.$store.dispatch('setTimeline',   obj.timeline)
    this.$store.dispatch('setEvidences',  obj.evidences)
    this.$store.dispatch('setOthers',     obj.others)
  },

  computed: {
    title: {
      get(){
        return this.$store.state.title
      },
      set(value){
        this.$store.dispatch('setTitle', value)
        this.saveSession()
      }
    },
    story: {
      get(){
        return this.$store.state.story
      },
      set(value){
        this.$store.dispatch('setStory', value)
        this.saveSession()
      }
    },
    characters: {
      get(){
        return this.$store.state.characters
      },
      set(value){
        this.$store.dispatch('setCharacters', value)
        this.saveSession()
      }
    },
    timeline: {
      get(){
        return this.$store.state.timeline
      },
      set(value){
        this.$store.dispatch('setTimeline', value)
        this.saveSession()
      }
    },
    evidences: {
      get(){
        return this.$store.state.evidences
      },
      set(value){
        this.$store.dispatch('setEvidences', value)
        this.saveSession()
      }
    },
    others: {
      get(){
        return this.$store.state.others
      },
      set(value){
        this.$store.dispatch('setOthers', value)
        this.saveSession()
      }
    }
  },

  methods: {
    saveSession(){
      const key = this.$route.params.id
      localStorage.setItem('session-' + key, JSON.stringify(this.$store.state))
    }
  }
}
</script>
